module.exports = "\n*{\n    font-family: Arial !important;\n}\n\n.hoz td{\n  border:1px solid;\n}"